module.exports = __webpack_public_path__ + "static/media/sprayCanIcon@3x.3552106c.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Customization/components/Customize/assets/sprayCanIcon@3x.png
// module id = 702
// module chunks = 0